import { render, staticRenderFns } from "./ProductAndPackageManagement.vue?vue&type=template&id=22667c6e&scoped=true"
import script from "./ProductAndPackageManagement.vue?vue&type=script&lang=js"
export * from "./ProductAndPackageManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductAndPackageManagement.vue?vue&type=style&index=0&id=22667c6e&prod&lang=scss&scoped=true"
import style1 from "./ProductAndPackageManagement.vue?vue&type=style&index=1&id=22667c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22667c6e",
  null
  
)

export default component.exports